import { Tip } from 'src/components/tip';

export default Tip;
